import * as React from "react";
import {
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
} from "@mui/material";
import PropTypes from "prop-types";

const SolicitarAnticipos = (props) => {
  const { open, onClose, onSave } = props;

  const [motivo, setMotivo] = React.useState("");

  React.useEffect(() => {
    open && setMotivo("");
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle fontSize="medium">
        ¿Desea solicitar un anticipo de viático?
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <TextField
            label="Motivo"
            size="small"
            multiline
            rows={2}
            autoFocus
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button disabled={!motivo} onClick={() => onSave({ motivo: motivo })}>
          Solicitar
        </Button>
        <Button onClick={onClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
};
SolicitarAnticipos.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};
export default SolicitarAnticipos;
